import { ChangeDetectorRef, Component, Injector, OnInit, ViewChild } from '@angular/core';
import { switchMap, takeUntil, tap, catchError} from 'rxjs/operators';
import { Observable, Subject, of } from 'rxjs';
import { PhysicianData } from '../../../@core/interfaces/masters/physician-mst';
import { DateService } from '../../../@theme/components/common/service/date.service';
import { FormBuilder, FormGroup,AbstractControl, Validators, FormArray} from '@angular/forms';
import * as period from '../../../data/period.json';
import { DatePipe, formatDate } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { EmployeeData } from '../../../@core/interfaces/masters/employee';
import { RehabImpMarketsMstData } from '../../../@core/interfaces/masters/rehab-imp-markets-mst';
import { NbTabComponent, NbTabsetComponent,NbDateService } from '@nebular/theme';
import { MedicineData } from '../../../@core/interfaces/masters/medicine';
import { FileExportService } from '../../../@core/backend/common/services/file-export.service';
import { VopdData } from '../../../@core/interfaces/vopd/vopd';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Location } from '@angular/common';
import { VaccineData } from '../../../@core/interfaces/masters/vaccine';
import { SalesMasterData } from '../../../@core/interfaces/masters/salesmaster';
import * as communication from './../../../data/auto-communication.json';
import { access } from '../../../data/access-constants';
import { RolesData } from '../../../@core/interfaces/common/roles';
import { PatientAppointment, PatientAppointmentData } from '../../../@core/interfaces/patient-services/patient-appointment';
import { ToastrAppSrvcService } from '../../../_services/toastr-app-srvc.service';
import { AdmissionreferralComponent } from '../../../@theme/components/common/admissionreferral/admissionreferral.component';
import { AbhaPrescriptionLinkService } from '../../ABHA/abha-prescription-link.service';


@Component({
  selector: 'ngx-referral-queue',
  templateUrl: './referral-queue.component.html',
  styleUrls: ['./referral-queue.component.scss']
})
export class ReferralQueueComponent implements OnInit {
  private branchId=localStorage.getItem('branchId');
  private tenantId = localStorage.getItem('tenantId');
  private createdBy = localStorage.getItem("userId");
  jobCategory=localStorage.getItem('jobCategoryId');
  protected readonly unsubscribe$ = new Subject<void>();
  @ViewChild('AdmissionreferralComponent') admissionRef: AdmissionreferralComponent;
  loadList:Array<any>=[];
  rootMappingDetails: Array<any> = [];
    groupedRootMappingDetails: Array<any> = [];

  currentDate: Date = new Date();
  p: number = 1;
  p1: number = 1;
  p2: number = 1;
  p3: number = 1;
  p5:number=1;
  p6:number=1;
  period: string ='Today';
  fromDate: Date;
  toDate: Date;
  rangeDate: Date[]=[];
  public commList: any[] = (communication as any).default;
  searchword:string;
  typeList:Array<any>=[{id:13,name:'Admission'},{id:14,name:'Appointment'}]
  searchForm:FormGroup;
  physiotherapyForm:FormGroup;
  moreDetails: boolean = false;
  periodList: string[] = (period as any).default;
  Tperiod:string='Today';
  Iperiod:string='Today';
  therpyterm:string;
  mobileTerm:string;
  DocList:Array<any>=[];
  Admissionperiod = [{ id: 1, name: 'Today' },{ id: 2, name: 'Within 2 Days' },{ id: 3, name: 'Within a Week' },{ id: 4, name: 'Within 15 Days' },
    { id: 5, name: 'Within 1 Month' },{ id: 6, name: 'Within 2 Month' },{ id: 7, name: 'Custom' }
  ]
  opFlag: number;
  callStatusList: Array<any> = [];
  patientFinalStatusList: Array<any> = [];
  counsellingStatusList: Array<any> = [];

  priorityList: Array<any> = [{ id: 1, name: 'Elective' }, { id: 2, name: 'Immediate' }, { id: 3, name: 'Emergency' }]
  statusList: Array<any> = [{ id: 4, name: 'New' }, { id: 5, name: 'Completed' }]
  categoryList: Array<any> = [{ id: 1, name: 'Surgery' }, { id: 2, name: 'Second opinion' }, { id: 3, name: 'Emergency care' }]
  pagename: string;
  therapyFlag: boolean = false;
  referralFlag: boolean = false;
  injectionFlag: boolean = false;
  durationList: Array<any> = [{ id: 1, display: "10 Minutes", value: 10, type: "minutes" }, { id: 2, display: "20 Minutes", value: 20, type: "minutes" },
  { id: 3, display: "30 Minutes", value: 30, type: "minutes" }, { id: 4, display: "40 Minutes", value: 40, type: "minutes" }, { id: 5, display: "1 Hour", value: 1, type: "hour" }
    , { id: 6, display: "2 Hours", value: 2, type: "hour" }, { id: 7, display: "Select Manual", value: 0, type: "manual" }];
  allnurseList: any;
  nurseList: any;
  therapyMstdata: any;
  loadListAll:Array<any>=[];
  therapy: string;
  therapist: string;
  Tstatus:string;
  TstatusList=[{id:5,name:'Therapy Completed'},{id:4,name:'Scheduled'}]
  Istatus:string;
  IstatusList=[{id:5,name:'Injection Completed'},{id:4,name:'Scheduled'}]
  Imobile:string='';
  Ireg:string="";
  openPatientStatusPopup: boolean = false;
  openCounsellingStatusPopup: boolean = false;
  showPopupStatusUpdate: boolean = false;
  primaryKey: number = 0;
  StatusId: number = 0;
  openStatusData: any;
  @ViewChild("tabSetRef") tabsetEl: NbTabsetComponent;
  @ViewChild("tabSetcounsel") counselTab: NbTabComponent;
  @ViewChild("tabPatientSights") patientSightsTab: NbTabComponent;
  medicineData:Array<any>=[];
  TabFlag:string=''
  InjectionName:string='';
  counsellingTypes: any[] = [{ id: 1, name: "Family Theraphy" }, { id: 2, name: "Group Theraphy" }, { id: 3, name: "Medidation" }];
  counsellingType:string;
  CstatusList=[{id:5,name:'Counselling Completed'},{id:4,name:'Scheduled'}];
  CarestatusList=[{id:5,name:'Completed'},{id:4,name:'Scheduled'},{id:6,name:'Hold'}];
  Cstatus:string;
  CregId:string;
  Cmobile:string;
  Cperiod:string;
  Carestatus:string;
  Caredoc:string;
  CareregId:string;
  Caremobile:string;
  patientCare:string;
  Careperiod:string;

  CommstatusList=[{id:5,name:'Completed'},{id:4,name:'Scheduled'},{id:6,name:'Hold'},{id:7,name:'Cancelled'},{id:8,name:'InProgress'}];
  Comm:string;
  CommregId:string;
  Commmobile:string;
  Commstatus:string;
  communiction:string;
  Commperiod:string;
  communicationList:Array<any>=[{id:'PHYSICIAN_TO_PHYSICIAN',name:'Physician Consultation'},{id:'PHYSICIAN_TO_NURSE',name:'Physician Orders'},{id:'NURSE_TO_PHYSICIAN',name:'Nurse Escalation'},{id:'NURSE_TO_NURSE',name:'Nurse Handover'}];
procedureList: any[] = [
  { id: '550e8400-e29b-41d4-a716-446655440001', name: 'Manual Therapy' },
  { id: '550e8400-e29b-41d4-a716-446655440002', name: 'Hydrotherapy' },
  { id: '550e8400-e29b-41d4-a716-446655440003', name: 'Electrotherapy' },
  { id: '550e8400-e29b-41d4-a716-446655440004', name: 'Therapeutic Exercise' }
];
patientCallStatusSearch?: number;
    patientFinalStatusSearch?: number;
    isAdmissionCreate:boolean=true;
  successFlag:boolean=false;
  failFlag:boolean=false;
  max:Date;
  admittedlist:Array<any>=[];
  VstatusList=[{id:5,name:'Vaccine Completed'},{id:4,name:'Scheduled'}]
  Vstatus:string;
  Vreg:string;
  Vperiod:string='Today';
  Vmobile:string='';
  p4:number=1;
  VaccineName:string;
  vaccineList:Array<any>=[];
  vaccineFlag:boolean=false;
  patientvaccineForm:FormGroup;
  patientStatusUpdateForm: FormGroup;
  VaccineMstData:any={};
  phlen:number=100;
  remarksCharLength: number = 100;
  phcharflag:boolean=false;
  remarksCharChangeFlag: boolean = false;
  value:string;
  isSubmitted:boolean=false;
  performDocList: any;
  performNurseList: any;
  medicineValue: any;
  stockDetforVaccineAdjust: any; //handled Object
  selectedMedicine: any;
  vaccineCheckBoxError: boolean;
  isFromNurseModule:boolean =false;
  commonType:Array<any>; 
  fromPhysioQueuePage : boolean =false;
  

  isPhysioView:boolean=true;
  isPhysioCreate:boolean=true;
  isPhysioEdit:boolean=true;
  isPhysioPrint:boolean=true;
  showReferaAdd: boolean = false;
  showReferAdd = false
  visitId: Number;
  regId: any;
  rootId: Number;
  counsellingInfo: Array<any> = [];
  visitLog: Array<any> = [];
  hoverVisible = false;
  hoverPosition = { x: 0, y: 0 };
  hideTimeout: any;
  editlistData: Array<any> = [];
  patientStatusUpdateFormSubmitted: boolean = false;
  isCounsellingCreate: boolean = false;
    isCounsellingUpdate: boolean = false;

  showCounsellingReferAdd:Boolean
  showCounsellFields:Boolean=true;
  filteredEditListData: Array<any> = [];
  admissionPage: any;
  bedReservationDet:Array<any> = [];

  isRereferal:boolean=false;
  reRefralId:number;
  refDocId:any;

  constructor(private datePipe: DatePipe,private injector: Injector,private cd: ChangeDetectorRef,private toaster: ToastrAppSrvcService,private patAptSrvc: PatientAppointmentData,private routers: Router,private filexport:FileExportService,protected phySrvc: PhysicianData,protected salesObj: SalesMasterData,public dateobj: DateService,private fb:FormBuilder, private router: Router ,private route:ActivatedRoute,protected employeeAPIService: EmployeeData,protected therapyMstSrvc:RehabImpMarketsMstData,protected medicineSrvc: MedicineData,protected vopdSrvc:VopdData,public location:Location,protected dateService: NbDateService<Date>,protected VaccineSrvc: VaccineData,protected rolesService: RolesData,private abhaPrescriptionLinkSrvc: AbhaPrescriptionLinkService) {
    this.searchForm=this.fb.group({
      type: this.fb.control(''),
      status:this.fb.control('',),
      priority:this.fb.control('',),
      reason:this.fb.control('',),
      fromDate: this.fb.control(null),
      toDate: this.fb.control(null),
      period:this.fb.control('Today'),
      mobile:this.fb.control(null),
      regId:this.fb.control(null),
      search:this.fb.control(null),
    });
    this.patientvaccineForm = this.fb.group({
      notes: this.fb.control(null),
      done_Date: this.fb.control(new Date(), [Validators.required]),
      performDoc: this.fb.control(null, [Validators.required]),
      performNurse: this.fb.control(null),
      regId: this.fb.control(null),
      medicineId:this.fb.control(null, [Validators.required]),
      doseNumber: this.fb.control(null, [Validators.pattern("^[0-9]+$")]),
      confirmVaccination: [false, Validators.requiredTrue]
    });
    this.physiotherapyForm = this.fb.group({
      procedureId: this.fb.control(null),
      numberOfSessions: this.fb.control(null),
      sessionDetails: this.fb.array([])
    });

    this.physiotherapyForm.get('numberOfSessions')!
      .valueChanges.subscribe(value => {
        if (!this.isPatching) {
          this.generateSessions(value);
        }
      });

  }

    get sessionDetails(): FormArray {
      return this.physiotherapyForm.get('sessionDetails') as FormArray;
    }

  isAddScheduling:boolean=false
  isUpdateScheduling:boolean=false
  scheduleDetails :any
  admissionId :any
  appointmentId :any
  docId :any
  departmentId :any
  QueueId:any
  isPatching = false;
  openScheduling(x:any){
    this.QueueId = x?.pcId
    this.regId = x?.regId    
    this.docId = x?.inputJson?.Therapist,   
    this.departmentId = this.findDoctorlistAndDepartment (x?.inputJson?.Therapist , 2),   
    this.admissionId = x?.admissionId    
    this.appointmentId = x?.appointmentId    
    this.scheduleDetails = {
      docId : x?.inputJson?.Therapist,
      departmentId : this.findDoctorlistAndDepartment (x?.inputJson?.Therapist , 2),
      status : x?.careTaskStatus ==4 ? 'Scheduled':'Completed',
      appointmentId : x?.appointmentId,
      admissionId : x?.admissionId,
      regId:x?.regId,
      
    }
    this.isAddScheduling = true


    this.listFn()


  }
listFn(){
    this.phySrvc.list(`PatientTherapy/GetByQueue/${this.QueueId}/${this.tenantId}/${this.branchId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    
    if(data){
       this.isPatching = true;
      this.physiotherapyForm.patchValue({
        procedureId: data.procedureId,
        numberOfSessions: data.numberOfSessions
      });
      this.sessionDetails.clear()
      if (data.sessions?.length) {
        data.sessions.forEach((s: any) => {
          this.sessionDetails.push(this.createSession(s));
        });
        this.isPatching = false;
      }
      this.isUpdateScheduling = false
    }else{
      this.isUpdateScheduling = true
    }

    },(err)=>{
      this.isUpdateScheduling = true
    },()=>{

    })
}
createSession(session?: any): FormGroup {
  return this.fb.group({
    therapyScheduleDetId: 0,
    tenantId:this.tenantId,
    branchId:this.branchId,
    therapyScheduleMstId : [session?.therapyScheduleMstId || null],
    therapyDate: [session?.therapyDate || null],
    therapyTime: [session?.therapyTime || null],
    therapyCaseType: [session?.therapyCaseType || 'OP'],
    visitId: [session?.visitId || null],
    therapyCaseId: [session?.therapyCaseId || null],
    sessionDurationMinutes: [session?.sessionDurationMinutes || 30],
  });
}


cancelScheduling(){
  this.isAddScheduling= false
}

  // generateSessions(count: number) {

  //   for (let i = 0; i < count; i++) {
  //     this.sessionDetails.push(
  //       this.fb.group({
  //         therapyDate: null ,
  //         therapyTime: null ,
  //         therapyCaseType: "Physio",
  //         visitId: null,
  //         therapyCaseId: null,
  //         sessionDurationMinutes: 30,
  //       })
  //     );
  //   }
  // }

generateSessions(count: number) {
  const currentCount = this.sessionDetails.length;

  // ➕ Add sessions
  if (count > currentCount) {
    for (let i = currentCount; i < count; i++) {
      this.sessionDetails.push(this.createSession());
    }
  }

  // ➖ Remove sessions
  if (count < currentCount) {
    for (let i = currentCount - 1; i >= count; i--) {
      this.sessionDetails.removeAt(i);
    }
  }
}


savetherapy(){
  

  const saveDto = {

  regId: this.regId,
  queueId: this.QueueId,
  therapyScheduleMstId: 0,
  procedureId: this.physiotherapyForm.get('procedureId').value,
  physicianId: this.scheduleDetails?.docId,
  numberOfSessions: this.physiotherapyForm.get('numberOfSessions').value,
  therapyStatus: this.scheduleDetails?.status,
  tenantId: this.tenantId,
  branchId: this.branchId,
  createdDate:new Date(),
  updatedDate:null,
  updatedBy:null,
  createdBy: parseInt(this.createdBy) ,
  sessions: this.physiotherapyForm.get('sessionDetails').value,

}

this.rolesService.create(`${environment.apiUrl}/PatientTherapy/save`, saveDto).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
  this.toaster.ForSuccess("Saved Sucessfully")
  this.listFn()
  
},(error)=>{
  this.toaster.ForDanger("Saved UnSucessfully")
})

}
doctorList:any
loadDoctorList(){
  const saveDto = {
    "searchWord": null,
    "fromDate": null,
    "toDate": null,
    "skip": 0,
    "take": 1000
}
const headers = new HttpHeaders({'Accept': 'application/json',});
  this.rolesService.createTable(`${environment.apiUrl}/dashboardOptimization/${this.tenantId}/${this.branchId}/GetDetailsForDashboard`, saveDto,{headers}).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    this.doctorList = data?.doctorAvailability

})
}
findDoctorlistAndDepartment(val:any,num:any){
  if(num == 1){
    const value = this.doctorList.find(x=>x.id === val)?.displayName 
    return value ?? '-'
  }else if (num == 2) {
    const value = this.doctorList.find(x=>x.id === val)?.departmentId 
    return value ?? '-'
  }

}
updatetherapy(){
  const saveDto = {
  regId: this.regId,
  queueId: this.QueueId,
  therapyScheduleMstId: 0,
  procedureId: this.physiotherapyForm.get('procedureId').value,
  physicianId: this.scheduleDetails?.docId,
  numberOfSessions: this.physiotherapyForm.get('numberOfSessions').value,
  therapyStatus: this.scheduleDetails?.status,
  tenantId: this.tenantId,
  branchId: this.branchId,
  createdDate:new Date(),
  updatedDate:null,
  updatedBy:null,
  createdBy: parseInt(this.createdBy) ,
  sessions: this.physiotherapyForm.get('sessionDetails').value,
  
}

this.rolesService.create(`${environment.apiUrl}/PatientTherapy/update`, saveDto).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
this.listFn()
this.toaster.ForSuccess("Updated Sucessfully")
})
}
showPrintSection:boolean
therapyScheduleMstId:number
openNotesPopup(index: number,visitId:any){

  if(visitId && visitId > 0 ? visitId : null){
    this.fromPhysioQueuePage = true
    this.visitId = visitId
    this.showPrintSection = true
  }else{

    let postdata: PatientAppointment = {
      tenantId: this.tenantId,
      branchId: this.branchId,
      doctorId: this.scheduleDetails?.docId,
      regId: this.regId,
      cancellationDate: null,
      bookingstatusId: "Booked",
      actualStartTime: null,
      actualEndTime: null,
      bookingChannelId: 1,
      type: "Clinic",
      departmentId:this.scheduleDetails?.departmentId,
      date: new Date(),
      slotTime: new Date(),
      duration: 10,
      createdBy:parseInt(localStorage.getItem("userId")),
      createdIP:null,
      createdDate: new Date(),
      updatedIP:null,
      updatedDate:null,
      updatedBy:null,
      amount:null,
      resetFromDate: this.dateobj.opdSequcenceResetFromDate(this.dateobj.currentDate()),
      resetToDate: this.dateobj.opdSequcenceResetToDate(this.dateobj.currentDate())
    }
this.patAptSrvc.createApptVisit(`patAppointment/${this.tenantId}/${this.branchId}/BookAppointmentFromCaseSheet`, postdata).pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
  this.fromPhysioQueuePage = true
  this.visitId = data?.visitId


    const sessionGroup = this.sessionDetails.at(index) as FormGroup;

    sessionGroup.patchValue({
        visitId: this.visitId
      });

      const saveDto = {

      regId: this.regId,
      queueId: this.QueueId,
      therapyScheduleMstId: sessionGroup?.value?.therapyScheduleMstId,
      procedureId: this.physiotherapyForm.get('procedureId').value,
      physicianId: this.scheduleDetails?.docId,
      numberOfSessions: this.physiotherapyForm.get('numberOfSessions').value,
      therapyStatus: this.scheduleDetails?.status,
      tenantId: this.tenantId,
      branchId: this.branchId,
      createdDate:new Date(),
      updatedDate:new Date(),
      updatedBy:parseInt(this.createdBy) ,
      createdBy: parseInt(this.createdBy) ,
      sessions: this.physiotherapyForm.get('sessionDetails').value,

    }

    this.rolesService.update(`${environment.apiUrl}/PatientTherapy/update`, saveDto).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.toaster.ForSuccess("Updated Sucessfully")
      this.showPrintSection = true
      this.listFn()
      
    },(error)=>{
      this.toaster.ForDanger("Updated UnSucessfully")
    })

})

  }


}


 get fval():{[key: string]: AbstractControl} { return this.patientvaccineForm.controls; }
 FetchPageAccess() {
    this.pageTaskIds = [];
    this.pageTaskIds.push(
      access.task.ADMMST,
       access.task.TASKORDERCOUNSELLING
      
    );
    let matrixSearchData = {
      taskId: this.pageTaskIds,
      UserId: localStorage.getItem("userType")
    }
    this.rolesService.create(`${environment.apiUrl}/userrole/${this.tenantId}/${this.branchId}/pageaccesssearch`, matrixSearchData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.userAccessData = data;
    }, (error) => {
    }, () => {
      
      // BOOK ADMISSION ACCESS
    let admissionCreate = this.userAccessData.some(element => access.task.ADMMST == element.taskID && element.actionID == access.action.VIEW && element.permission == "true");
    this.isAdmissionCreate=admissionCreate;
    
         let counsellingCreate = this.userAccessData.some(element => access.task.TASKORDERCOUNSELLING == element.taskID && element.actionID == access.action.CREATE && element.permission == "true");
          this.isCounsellingCreate=counsellingCreate;

          let counsellingUpdate = this.userAccessData.some(element => access.task.TASKORDERCOUNSELLING == element.taskID && element.actionID == access.action.EDIT && element.permission == "true");
          this.isCounsellingUpdate=counsellingUpdate;

    });

  }  ngOnInit(): void {
  this.fetchPageAccess();
      this.loadDoctorList()
    this.route.paramMap.subscribe(params => {
      this.pagename = params.get('page') || '';
      this.handlerFtn();
    });
    this.max = this.dateService.addDay(new Date(Date.now()), 0);
  }

closeCounselPopup(){
      this.showCounsellingReferAdd = false;
      this.onLoad()
  }
  openCounselPopup(x) {
    this.loadlog(x.regId, x.visitId)
    this.showCounsellingReferAdd = true;
    this.visitId = x.visitId
    this.regId = x.regId
    this.rootId = x.pcId
  }

  hasPdci(pcId: number): boolean {
    if (!this.rootMappingDetails) return false;
    return this.rootMappingDetails.some(item => item.parentId === pcId);
  }
  openReferPopup(x) {
    // this.loadlog(x.regId, x.visitId)
    this.showReferAdd = true;
    this.visitId = x.visitId
    this.regId = x.regId
    this.rootId = x.pcId
  }
  closeReferPopup() {
    this.showReferAdd = false;
    this.onLoad()
  }

  loadlog(regId, visitId) {
    this.vopdSrvc.list(`appointmentstatusdetail/${this.tenantId}/${this.branchId}/${regId}/GetallAppointmentStatusDetails?visitId=${visitId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.visitLog = data.details;
    })
  }
  showCounsellDetails(row, pcId: number, event: MouseEvent){
        this.hoverVisible = true;

    this.hoverPosition = {
      x: event.clientX + 15,
      y: event.clientY + 15
    };
         this.visitId = row.visitId;
        this.regId = row.regId;
        this.rootId = pcId;
        this.visitLog = row;

      this.filteredEditListData = this.editlistData.filter(item => item.parentId === pcId
  );
  }

  showDetails(row, pcId: number, event: MouseEvent) {
    this.hoverVisible = true;

    this.hoverPosition = {
      x: event.clientX + 15,
      y: event.clientY + 15
    };

    this.vopdSrvc.list(
      `PatientCareTaskMaster/GetCounsellingDetailsByRootId?tenantId=${this.tenantId}&branchId=${this.branchId}&rootId=${pcId}`
    )
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res: any) => {
        
        this.editlistData = res.details;
        this.editlistData = this.editlistData.map(x => {
          return {
            ...x,
            parsedJson: JSON.parse(x.inputJson)   // ? parse only once
          };
        });

        this.visitId = row.visitId;
        this.regId = row.regId;
        this.rootId = pcId;
        this.visitLog = row;
      });
  }
  hideDelayed() {
    this.hideTimeout = setTimeout(() => {
      this.hoverVisible = false;
    }, 300);
  }

  cancelHide() {
    clearTimeout(this.hideTimeout);
  }
    editThisRecord(data) {
    this.vopdSrvc.list(`PatientCareTaskMaster/getCareTaskDetailsById?tenantId=${this.tenantId}&branchId=${this.branchId}&id=${data.id}`).pipe(takeUntil(this.unsubscribe$)).subscribe((res: any) => {
      this.showReferAdd = true;
      if (res?.details?.inputJson) {
        let parsed: any = {};
        parsed = JSON.parse(res.details.inputJson);
        res.details = {
          ...res.details,
          ...parsed
        };
      }
      setTimeout(() => {
        this.admissionRef.callEdit(res.details);
      }, 50);
    });
  }
  handlerFtn(){
    if(this.pagename == 'Appointment'){
      this.referralFlag = true;
      this.isFromNurseModule=false
      this.isPrint=true
      this.isExport=true
      this.searchForm.get('period').setValue('Today');
      this.searchForm.get('type')?.setValue(14)
      this.onLoad();
    }
    else if(this.pagename == 'cathlab'){
      this.referralFlag = true;
      this.isFromNurseModule=false
      this.isPrint=true
      this.isExport=true
      this.searchForm.get('period').setValue('Today');
      this.searchForm.get('type')?.setValue(31)
      this.onLoad();
    }else if(this.pagename == 'diet'){
      this.referralFlag = true;
      this.isFromNurseModule=false
      this.isPrint=true
      this.isExport=true
      this.searchForm.get('period').setValue('Today');
      this.searchForm.get('type')?.setValue(32)
      this.onLoad();
    }else if(this.pagename == 'Admission'){
      this.referralFlag = true;
      this.isFromNurseModule=false
      this.isPrint=true
      this.isExport=true
      this.searchForm.get('period').setValue('Today');
      this.searchForm.get('type')?.setValue(13)
      this.onLoad();
    }else if(this.pagename == 'Queue'){
      this.referralFlag = false;
      this.isFromNurseModule=false
      this.isPrint=true
      this.isExport=true
      setTimeout(()=>{
        this.tabsetEl?.selectTab(this.counselTab);
      },200)
    }
    else if(this.pagename == 'Nurse'){
      this.TabFlag='Patient Insights'
      this.referralFlag = false;
      this.isFromNurseModule=true
      this.isPrint=false
      this.isExport=false
      this.fetchPageAccess()
      setTimeout(()=>{
        this.tabsetEl?.selectTab(this.patientSightsTab);
      },500)
    }
    const arr =['referralPatientId', 'referralFlag', 'refVisit', 'DEPTID', 'DOCID','refPcId','refappt','refRegId'];
    arr.forEach((key) => {
      if (localStorage.getItem(key) !== null) {
        localStorage.removeItem(key);
      }
    });
  }

  loadDatadet(flag,det){
    if(flag=='nurse'){
      return this.performNurseList?.find(e => e?.id == det)?.firstName ||'-'

    }else if(flag=='doc'){
      return (this.performDocList?.find(e => e?.id == det)?.doctor+this.performDocList?.find(e => e?.id == det)?.displayName)||'-'

    }else if(flag=='meds'){
       return this.medicineValue?.find(e => e?.medicineid == det)?.medicineName||'-'

    }

  }

getCounsellingStatusById(id) {
  return this.counsellingStatusList?.find(s => s.id === id)?.name ?? 'N/A';
}


  openCounsellingStatusPopupDialog(data){
    this.openCounsellingStatusPopup=true;
        this.primaryKey = null;

        this.openStatusData = data;
        this.primaryKey = data?.pcId;
        debugger
        this.StatusId=data.careTaskStatus;

  }

  openPatientStatusPopupDialog(data) {
    this.openPatientStatusPopup = true;
    this.patientStatusUpdateForm.reset();
    this.primaryKey = null;
    //this.callCategoryAPI();
    //this.fetchPatientCareFinalStatus();
    
    this.primaryKey = data?.pcId;
    this.openStatusData = data;
    if (data?.doneDateTime) {
      this.patientStatusUpdateForm.get('counsellingDate')?.setValue(
        this.dateobj.dateUtctoLocalDateAndTime(data.doneDateTime)
      );
    }
    this.patientStatusUpdateForm.get('remarks').setValue(data?.remarks);
    this.patientStatusUpdateForm.get('patientCallStatus').setValue(data?.patientCallStatusId);
    this.patientStatusUpdateForm.get('patientFinalStatus').setValue(data?.patientFinalStatusId);
    this.patientStatusUpdateForm.get('counsellingStatus').setValue(data?.careTaskStatus);

  }

 getAdmitStatus(): string {
  
  return this.patientFinalStatusList.find(e => e?.sortOrder === 4)?.name || '';
}


  fetchPatientCareFinalStatus() {
    if (this.patientFinalStatusList.length == 0) {

      this.employeeAPIService.list("PatientCareTaskMaster/getPatientCareFinalStatus").pipe(takeUntil(this.unsubscribe$)).subscribe((returnData: any) => {
        this.patientFinalStatusList = returnData.details;
      }, (error) => {

      }, () => {
      });


    }

  }
  fetchCounsellingStatus() {
    if (this.counsellingStatusList.length == 0) {
      this.employeeAPIService.list("PatientCareTaskMaster/getCounsellingStatus").pipe(takeUntil(this.unsubscribe$)).subscribe((returnData: any) => {
        this.counsellingStatusList = returnData.details;
      }, (error) => {

      }, () => {
      });


    }

  }

  callCategoryAPI() {
    const masterTypes = {
      masterTypes: ["CALL_STATUS"]
    }
    if (this.callStatusList?.length == 0) {
      this.rolesService.create(`${environment.apiUrl}/tenants/${this.tenantId}/masterreason/${this.branchId}/getMultipleTenantBasedMasters`, masterTypes).pipe(takeUntil(this.unsubscribe$)).subscribe((responseData: any) => {
        const response = responseData.details;
        this.callStatusList = response.filter(each => each.mrType === 'CALL_STATUS' && each.isActive == true);
      })
    }
  }

  onCalculation(ids) {
    return ids ? this.Admissionperiod?.find(x => x?.id == ids)?.name || '-' : '-'
  }
  commonListPage(responseData) {
    this.loadList = responseData?.details?.map((x) => {
      const leet = { ...x, inputJson: JSON.parse(x?.inputJson) };
      return leet;
    });
    this.rootMappingDetails = responseData.rootMappingDetails;
    this.cd.detectChanges();
    this.loadListAll = [...this.loadList];
    if (this.referralFlag) {
      this.p = 1;
      this.loadList = this.loadListAll.filter(item => {
        return (
          (!this.searchForm.get('status')?.value || item.careTaskStatus == this.searchForm.get('status')?.value) &&
          (!this.searchForm.get('mobile')?.value || item.mobile == this.searchForm.get('mobile')?.value) &&
          (!this.searchForm.get('regId')?.value || item?.regNum == this.searchForm.get('regId')?.value) &&
          (!this.searchForm.get('priority')?.value || item.inputJson?.Mode == this.searchForm.get('priority')?.value)
        )
      });
      if (this.opFlag == 13) {
        this.admittedlist = this.loadList?.filter(x => x?.careTaskStatus == 5);
        this.loadList = this.loadList.map(y => {
          if (y?.careTaskStatus == 4) {
            return {
              ...y,
              alreadyadmit: this.alreadyAdmitted(y.regId)
            };
          } else {
            return {
              ...y,
              alreadyadmit: false
            };
          }
        })
      } else {
        this.admittedlist = [];
      }


    } else if (!this.referralFlag) {
      if (this.TabFlag == 'Therapy') {
        this.loadList = this.loadListAll.filter(item => {
          return (
            (!this.therapist || item?.inputJson?.Therapist == this.therapist) &&
            (!this.therapy || item.inputJson?.Description == this.therapy) &&
            (!this.Tstatus || item.careTaskStatus == this.Tstatus) &&
            (!this.mobileTerm || item.mobile == this.mobileTerm?.trim()) &&
            (!this.therpyterm || item.regNum == this.therpyterm?.trim()))


        })
      }
      else if (this.TabFlag == 'Injection') {
        this.loadList = this.loadListAll.filter(item => {
          return (
            (!this.InjectionName || item.inputJson?.injection == this.InjectionName) &&
            (!this.Istatus || item.careTaskStatus == this.Istatus) &&
            (!this.Imobile || item.mobile == this.Imobile?.trim()) &&
            (!this.Ireg || item.regNum == this.Ireg?.trim()))

        })
      }
      else if (this.TabFlag == 'Vaccine') {
        this.loadList = this.loadListAll.filter(item => {
          return (
            (!this.VaccineName || item.inputJson?.vaccineId == this.VaccineName) &&
            (!this.Vstatus || item.careTaskStatus == this.Vstatus) &&
            (!this.Vmobile || item.mobile == this.Vmobile?.trim()) &&
            (!this.Vreg || item.regNum == this.Vreg?.trim()))

        })
      }
      else if (this.TabFlag == 'Counsel') {
        this.loadList = this.loadListAll.filter(item => {
          return (
            (!this.counsellingType || item.inputJson?.counsellingId == this.counsellingType) &&
            (!this.Cstatus || item.careTaskStatus == this.Cstatus) &&
            (!this.Cmobile || item.mobile == this.Cmobile?.trim()) &&
            (!this.CregId || item.regNum == this.CregId?.trim()))

        })
      }
    }

    this.loadList?.sort((a, b) => {
      return new Date(b?.createdDate)?.getTime() - new Date(a?.createdDate)?.getTime();
    });
  }
  onLoad(){
      var date = this.dateobj.currentDate();
      if (this.period != "" && this.period != "Between") {
        switch (this.period) {
          case 'Today':
            this.rangeDate = null;
            this.fromDate = date;
            this.toDate = date;
            break;
          case 'Yesterday':
            date.setDate(date.getDate() - 1);
            this.fromDate = date;
            this.toDate = date;
            break;
          case 'This Week':
            var today = new Date(date.getFullYear(), date.getMonth(), date.getDate());
            this.fromDate = new Date(today.setDate(today.getDate() - today.getDay()));
            this.toDate = date;
            break;
          case 'This Month':
            this.fromDate = new Date(date.getFullYear(), date.getMonth(), 1);
            this.toDate = date;
            break;
          case 'This Year':
            this.fromDate = new Date(date.getFullYear(), 0, 1);
            this.toDate = date;
            break;
          case 'All':
            this.fromDate = null;
            this.toDate = date;
            break;
          default:
            break;
        }
      }
        if (this.rangeDate !== null && this.rangeDate !== undefined) {
          if (this.rangeDate[0] !== null && this.rangeDate[0] !== undefined && (this.rangeDate[1] == null || this.rangeDate[1] == undefined)) {
            this.fromDate = this.rangeDate[0];
            this.toDate = date;
          }
          else if (this.rangeDate[1] !== null && this.rangeDate[1] !== undefined && (this.rangeDate[0] == null || this.rangeDate[0] == undefined)) {
            this.fromDate = null;
            this.toDate = this.rangeDate[1];
          }
          else if (this.rangeDate[1] !== null && this.rangeDate[1] !== undefined && (this.rangeDate[0] != null && this.rangeDate[0] != undefined)) {
            this.fromDate = this.rangeDate[0];
            this.toDate = this.rangeDate[1];
          }
        }
      if (this.searchword == "")
        this.searchword = null;
      let searchData = {
        "tenantId": this.tenantId,
        "branchId": this.branchId,
        'fromDate': this.dateobj.utcFromDate(this.fromDate),
        'toDate': this.dateobj.utcToDate(this.toDate),
      "careTaskType": this.searchForm.get('type')?.value,
      "patientCallStatus": this.patientCallStatusSearch,
      "patientFinalStatus": this.patientFinalStatusSearch
    }
    this.opFlag = this.searchForm.get('type')?.value;
    this.phySrvc.searchList(`PatientCareTaskMaster/GetAllDataBasedOnReferralQueue`, searchData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.bedReservationDet = data?.bedReservationDet || [];

      this.commonListPage(data);
          if(data?.rootMappingDetails){
         this.editlistData = data?.rootMappingDetails.map(x => {
          return {
            ...x,
            parsedJson: JSON.parse(x.inputJson) 
          };
        });
    }
      this.loadList = data?.details?.map((x)=>{
        const leet = { ...x, inputJson: JSON.parse(x?.inputJson) };
        return leet;
      });
      this.loadListAll = [...this.loadList];
      if(this.referralFlag){
        this.p=1;
        this.loadList = this.loadListAll.filter(item => {
          return (
            (!this.searchForm.get('status')?.value ||  item.careTaskStatus == this.searchForm.get('status')?.value) &&
            (!this.searchForm.get('mobile')?.value || item.mobile == this.searchForm.get('mobile')?.value) &&
            (!this.searchForm.get('regId')?.value || item?.regNum == this.searchForm.get('regId')?.value) &&
            (!this.searchForm.get('priority')?.value || item.inputJson?.Mode == this.searchForm.get('priority')?.value) 
          )});
          if(this.opFlag == 13){
            this.admittedlist = this.loadList?.filter(x => x?.careTaskStatus == 5);
            this.loadList = this.loadList.map(y =>{
              if(y?.careTaskStatus == 4){
                return {
                  ...y,
                  alreadyadmit: this.alreadyAdmitted(y.regId)
              }; }else{  return {
                ...y,
                alreadyadmit: false
            };}
            })
          }else{
            this.admittedlist = [];
          }


      }else if(!this.referralFlag){
      if(this.TabFlag == 'Therapy'){
        this.loadList = this.loadListAll.filter(item => {
          return (
            (!this.therapist || item?.inputJson?.Therapist == this.therapist) &&
            (!this.therapy || item.inputJson?.Description == this.therapy)&&
            (!this.Tstatus || item.careTaskStatus == this.Tstatus)&&
            (!this.mobileTerm || item.mobile == this.mobileTerm?.trim())&&
            (!this.therpyterm || item.regNum == this.therpyterm?.trim()) )


        })}
        else if(this.TabFlag == 'Injection'){
          this.loadList = this.loadListAll.filter(item => {
            return (
              (!this.InjectionName || item.inputJson?.injection == this.InjectionName)&&
              (!this.Istatus || item.careTaskStatus == this.Istatus)&&
              (!this.Imobile || item.mobile == this.Imobile?.trim())&&
            (!this.Ireg || item.regNum == this.Ireg?.trim()) )
  
          })}
          else if(this.TabFlag == 'Vaccine'){
            this.loadList = this.loadListAll.filter(item => {
              return (
                (!this.VaccineName || item.inputJson?.vaccineId == this.VaccineName)&&
                (!this.Vstatus || item.careTaskStatus == this.Vstatus)&&
                (!this.Vmobile || item.mobile == this.Vmobile?.trim())&&
              (!this.Vreg || item.regNum == this.Vreg?.trim()) )
    
            })
            this.loadList = this.loadList.map(item => ({
              ...item,
              inputJson: {
                ...item.inputJson,
                performingDoctorName: this.loadDatadet('doc',item.inputJson?.performingDoctor),
                medicineName: this.loadDatadet('meds',item.inputJson?.vaccineId),
                performingNurseName: this.loadDatadet('nurse',item.inputJson?.performingNurse)
              }
            }));
          }
          else if(this.TabFlag =='Counsel'){
            this.loadList = this.loadListAll.filter(item => {
              return (
                (!this.counsellingType || item.inputJson?.counsellingId == this.counsellingType)&&
                (!this.Cstatus || item.careTaskStatus == this.Cstatus)&&
                (!this.Cmobile || item.mobile == this.Cmobile?.trim())&&
              (!this.CregId || item.regNum == this.CregId?.trim()) )
    
            })
          }
          else if(this.TabFlag =='PatientCare'){
            this.loadList = this.loadListAll.filter(item => {
              return (
                (!this.patientCare || item.inputJson?.name == this.patientCare)&&
                (!this.Carestatus || item.careTaskStatus == this.Carestatus)&&
              (!this.CareregId || item.regNum == this.CareregId?.trim()) )&&
               (!this.Caredoc || item?.inputJson?.doctor == this.Caredoc?.trim()) 
    
            })
          }
          else if(this.TabFlag =='CommunicationOrder'){
            this.loadList = this.loadListAll.filter(item => {
              return (
                (!this.communiction || item.inputJson?.communicationType == this.communiction)&&
                (!this.Commstatus || item.careTaskStatus == this.Commstatus)&&
              (!this.CommregId || item.regNum == this.CareregId?.trim()) )&&
               (!this.Commmobile || item?.mobile == this.Commmobile?.trim()) 
    
            })
          }
        }
      })

      this.loadList = this.loadList.map(item => ({
        ...item,
        showMore: false
      }));
    this.callCategoryAPI();
    this.fetchPatientCareFinalStatus();
    this.fetchCounsellingStatus();
    this.loadList = this.loadList?.sort((a, b) => {
      return new Date(b?.createdDate)?.getTime() - new Date(a?.createdDate)?.getTime();
    });
  }
  periodChange(data: any[]){ 
    this.period = data[0]?.value;
    this.searchForm.get('period').setValue(this.period);
    if(data[0]?.value=="Between"){
    this.searchForm.get('fromDate').setValue(null);
    this.searchForm.get('toDate').setValue(null);
     this.moreDetails=true;}
    else{
      this.searchForm.get('fromDate').setValue(null);
      this.searchForm.get('toDate').setValue(null);
      this.rangeDate=null;
      this.moreDetails=false;
     }
  }
  onDateChoose() { 
    var fromDate=this.searchForm.get('fromDate').value;
    var toDate=this.searchForm.get('toDate').value;
      this.rangeDate=[];
    if (fromDate != undefined && toDate != undefined && fromDate!=null && fromDate!="" 
    && toDate!=null && toDate!="") {
      fromDate = formatDate(fromDate, 'yyyy-MM-dd', 'en-US');
      toDate = formatDate(toDate, 'yyyy-MM-dd', 'en-US');
      if (fromDate <= toDate) {
      fromDate=this.searchForm.get('fromDate').value;
      toDate=this.searchForm.get('toDate').value;
      this.rangeDate.push(fromDate!=null?fromDate[0]:null);
      this.rangeDate.push(toDate!=null?toDate[1]:null);
      }
      else {
        this.rangeDate.push(null);
        this.rangeDate.push(null);
      }
    }  
  }
  fetchDoctor(){
    if(this.DocList?.length > 0)return;
    this.phySrvc.list(`physicians/${this.tenantId}/${this.branchId}/GetAllInternalDoctor`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {this.DocList = data},(err)=>{},()=>{})
  }
  prevclicked() {
    if(this.referralFlag){
      if (this.p> 1)
        this.p = this.p - 1
    }else if(!this.referralFlag){
      if(this.TabFlag=='Injection'){
        if (this.p2 > 1)
          this.p2 = this.p2 - 1
      }
      else if( this.TabFlag=='Therapy'){
        if (this.p1 > 1)
          this.p1 = this.p1 - 1
      }
      else if(  this.TabFlag=='Counsel'){
        if (this.p3 > 1)
          this.p3 = this.p3 - 1
      }
      else if(  this.TabFlag=='Vaccine'){
        if (this.p4 > 1)
          this.p4 = this.p4 - 1
      }
       else if(  this.TabFlag=='PatientCare'){
        if (this.p5 > 1)
          this.p5 = this.p5 - 1
      }else if(  this.TabFlag=='CommunicationOrder'){
        if (this.p6 > 1)
          this.p6 = this.p6 - 1
      }

    }
  }
  nextclicked() {
    if(this.referralFlag){
      if (this.p < (this.loadList.length / 10))
        this.p = this.p + 1
    }else if(!this.referralFlag){
      if(this.TabFlag=='Injection'){
        if (this.p2 < (this.loadList.length / 10))
          this.p2 = this.p2 + 1
      }
      else if( this.TabFlag=='Therapy'){
        if (this.p1 < (this.loadList.length / 10))
          this.p1 = this.p1 + 1
      }
      else if(  this.TabFlag=='Counsel'){
        if (this.p3 < (this.loadList.length / 10))
          this.p3 = this.p3 + 1
      }
      else if(  this.TabFlag=='Vaccine'){
        if (this.p4 < (this.loadList.length / 10))
          this.p4 = this.p4 + 1
      }
      else if(  this.TabFlag=='PatientCare'){
        if (this.p5 < (this.loadList.length / 10))
          this.p5 = this.p5 + 1
      }
       else if(  this.TabFlag=='CommunicationOrder'){
        if (this.p6 < (this.loadList.length / 10))
          this.p6 = this.p6 + 1
      }

    }
  }
  onReset(){
    this.period='Today'
    this.searchForm.get('period').setValue(this.period);
    if(this.pagename == 'Appointment'){
      this.searchForm.get('type')?.setValue(14);
      this.onLoad();
    }
    else if(this.pagename == 'cathlab'){
      this.searchForm.get('type')?.setValue(31);
      this.onLoad();
    }else if(this.pagename == 'diet'){
      this.searchForm.get('type')?.setValue(32);
      this.onLoad();
    }else{
      this.searchForm.get('type')?.setValue(13);
      this.onLoad();
    }
    this.searchForm.get('mobile')?.reset();
    this.searchForm.get('regId')?.reset();
    this.searchForm.get('status')?.reset();
    this.searchForm.get('priority')?.reset();
    this.searchForm.get('reason')?.reset();
  }
  onSearch(){}

  BookAppointment(x,event){
    event.target.disabled=true;
    localStorage.setItem('referralFlag','true')
    localStorage.setItem('refPcId',x?.pcId)
    localStorage.setItem('refRegId',x?.regId)
    localStorage.setItem('refVisit',x?.visitId)
    localStorage.setItem('refappt',x?.inputJson?.oldApp)
    localStorage.setItem('refDate', x.inputJson?.DateTime);
    if(this.opFlag == 13){
      localStorage.setItem('DOCID',x.inputJson?.docid)
      localStorage.setItem('DEPTID',x.inputJson?.depid)
      this.router.navigate([`${'/pages/ip/admission/'+x.regId+'/'+0}`]);
      event.target.disabled=false;
    }
    else if(this.opFlag ==31){
      this.router.navigate([`/pages/ot/patient-ot-list`], { queryParams: { data: x.regId+'_DayCare',isCathLab:'true' } });
      event.target.disabled=false;
    }
    else{
  localStorage.setItem('referralPatientId',x.regNum)
    this.router.navigate([`/pages/patientservices/doctor-appointment/${x.inputJson?.docid}/${x.inputJson?.depid}/add/null/null`], { queryParams: { name: x.inputJson?.docName +"="+x.inputJson.deptName } });}
    event.target.disabled=false;
  }
  utcToLocalConversion(date) {
    if (date != null && date != "" && date != undefined) {
      return this.dateobj?.dateUtctoLocalDateAndTime(date);
    }
  }
  getDurationNamebyId(id):string{
    if(id!=null){
      var test =this.durationList.find(e=>e.id==id);
      return test.display;
    }
  }

  findCounsellingName(inputId) {
    return this.counsellingTypes.find((item) => item.id == inputId)?.name;
  }
  
  findCareName(inputId) {
    return this.commonType.find((item) => item.mrId == inputId)?.reasonName;
  }
  
  getCareStatus(id) {
    if (id != null) {
      var test = this.CarestatusList.find(e => e.id == id);
      return test.name;
    }
  }

  findPriority(inputId) {
    return this.priorityList.find((item) => item.id == inputId)?.name;
  }

  findCategory(inputId) {
    return this.categoryList.find((item) => item.id == inputId)?.name;
  }

  

  getTStatus(id): string {
    if (id != null) {
      var test = this.TstatusList.find(e => e.id == id);
      return test.name;
    }
  }

  getStatus(id): string {
    if (id != null) {
      var test = this.statusList.find(e => e.id == id);
      return test.name;
    }
  }
  getVaccineName():string{
    var test =this.vaccineList?.find(item =>
      (!this.VaccineName || item.id == this.VaccineName)
    );
    return test?.name;
  }

  getInjectionName(): string {
    var test =this.medicineData?.find(item =>
      (!this.InjectionName || item?.id == this.InjectionName)
    );
          return test?.name;

  }


  getIStatus(id): string {
    if (id != null) {
      var test = this.IstatusList.find(e => e.id == id);
      return test.name;
    }
  }

  getCStatus(id): string {
    if (id != null) {
      var test = this.CstatusList.find(e => e.id == id);
      return test.name;
    }
  }

  async mergeDrAndNurse(): Promise<boolean> {
    this.nurseList = [];
    this.nurseList = [...this.allnurseList,...this.DocList];
    return true;

  }
  loadEmployee(): void {
    this.employeeAPIService.list("tenants/" + this.tenantId + '/' + this.branchId + '/employee/loadTherapistList').pipe(takeUntil(this.unsubscribe$)).subscribe((returnData: any) => {
      this.nurseList = returnData.data;
      this.allnurseList=returnData.data;
    }, (error) => {

    }, () => {
      this.mergeDrAndNurse();
    });
  }
  getTherapistName(therapistist):string{
    if(therapistist!=null && therapistist!=undefined){
    
      const splitTherapist = therapistist.split(',');
      
      var therapistName=" ";
      splitTherapist?.forEach(x => {
        var userData= this.nurseList?.find(s=>s?.id===x);
        therapistName+=(userData?.displayName==undefined ? userData?.name : ( userData?.doctor + ' ' +userData?.displayName))+", ";
      });
      return therapistName;
    
    }
    return "-";
    
      }

      therapyFtn(id){
        if(id !== null && id!=undefined){
        return this.therapyMstdata?.find(x => x?.id == id)?.name}
        return '-';
      }
      therapyMstList(){
        this.therapyMstSrvc.list('rehabImpMarkersMst/getRehabImprovementMaster?tenantId=' + this.tenantId + '&branchId=' + this.branchId).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
          this.therapyMstdata = data?.details?.filter(item => item?.isActive === true);    
      
        }, (error) => {
      
        }, () => {
      
        });
      }

      onSearchTherapy(): void {
       this.period = this.Tperiod;
       this.p1=1;
       this.searchForm.get('type')?.setValue(10)
       this.onLoad();
      }
    
      onResetTherapy(): void {
        this.therpyterm ='';
        this.mobileTerm ='';
        this.Tstatus='';
        this.therapist='';
        this.therapy='';
        this.Tperiod='Today';
        this.moreDetails=false;
        this.onSearchTherapy();
      }
      onSearchInjection(): void {
        this.period = this.Iperiod;
        this.p2=1;
        this.searchForm.get('type')?.setValue(12)
        this.onLoad();
       }
       onResetInjection(): void {
        this.InjectionName ='';
        this.Istatus='';
        this.Ireg='';
        this.Imobile='';
        this.moreDetails=false;
        this.Iperiod='Today';
        this.onSearchInjection();
      }
      onSearchVaccine(): void {
        this.period = this.Vperiod;
        this.p4=1;
        this.searchForm.get('type')?.setValue(26)
        this.onLoad();
       }
       onResetVaccine(): void {
        this.VaccineName ='';
        this.Vstatus='';
        this.Vreg='';
        this.Vmobile='';
        this.moreDetails=false;
        this.Vperiod='Today';
        this.onSearchVaccine();
      }
      onSearchCounsel(): void {
        this.period = this.Cperiod;
        this.p3=1;
        this.searchForm.get('type')?.setValue(11)
        this.onLoad();
       }
       onResetCounsel(): void {
        this.Cstatus='';
        this.CregId='';
        this.Cmobile='';
        this.counsellingType=''
        this.moreDetails=false;
        this.Cperiod='Today';
        this.onSearchCounsel();
      }
      onSearchPatientCare(): void {
        this.period = this.Careperiod;
        this.p5=1;
        this.searchForm.get('type')?.setValue(29)
        this.onLoad();
       }
       onResetPatientCare(): void {
        this.Carestatus='';
        this.CareregId='';
        this.patientCare=''
        this.moreDetails=false;
        this.Caredoc='';
        this.Careperiod='Today';
        this.onSearchPatientCare();
      }
      onSearchCommunication(): void {
        this.period = this.Commperiod;
        this.p6=1;
        this.searchForm.get('type')?.setValue(30)
        this.onLoad();
       }
       onResetCommunication(): void {
        this.Commstatus='';
        this.CommregId='';
        this.communiction=''
        this.moreDetails=false;
        this.Commmobile='';
        this.Commperiod='Today';
        this.onSearchCommunication();
      }
       

      onTabChange(val){
        if(val.tabTitle == 'Counselling Queue'){
          this.TabFlag='Counsel'
          this.onResetCounsel();
        }
        else if(val.tabTitle == 'Therapy Queue'){
          this.TabFlag='Therapy'
          this.therapyMstList();
          this.fetchDoctor()
          this.loadEmployee();
          this.onResetTherapy();
        }
        else if(val.tabTitle == 'Injection Queue'){
          this.TabFlag='Injection'
          this.loadInj()
          this.onResetInjection()
        } else if (val.tabTitle == 'Vaccination Queue') {
          this.TabFlag = 'Vaccine'
          this.performDoc().pipe(
            catchError(() => of(null)),
            switchMap(() => this.performNurse().pipe(catchError(() => of(null)))),
            switchMap(() => this.LoadVaccine().pipe(catchError(() => of(null))))
          ).subscribe(() => {
            this.onResetVaccine();
          });
        }
        else if (val.tabTitle == 'Patient Insights') {
          this.TabFlag = val.tabTitle
        }
         else if(val.tabTitle == 'Patient Care Queue'){
          this.TabFlag='PatientCare';
          // this.fetchDoctor();
          // this.fetchTenantBasedList();
          this.onResetPatientCare()
        }
          else if(val.tabTitle == 'Communication Order Queue'){
          this.TabFlag='CommunicationOrder';
          // this.fetchDoctor();
          // this.fetchTenantBasedList();
          this.onResetCommunication()
        }
      }
      getDepart(id){
        if(id!=null && id!=undefined){    
          var userData= this.nurseList?.find(s=>s?.id===id);  
          var therapistName=(userData?.departmentName ? userData?.departmentName:userData?.department?.name)|| '-';
          return therapistName ||'-';
        }
        return "-"

    }
    LoadVaccine(): Observable<any> {
      if (this.vaccineList?.length == 0) {
        return this.VaccineSrvc.list(`vaccine/${this.tenantId}/${this.branchId}`).pipe(
          takeUntil(this.unsubscribe$),
          tap((data: any) => {
            this.vaccineList = data;
          }),
          catchError(() => of(null))
        );
      }
      return of(this.vaccineList);
    }

    markAsDone(x,event){
      event.target.disable=true;
      const Det={};
      const params=new HttpParams().set('tenantId',this.tenantId).set('branchId',this.branchId).set('pcId',x?.pcId)
      this.vopdSrvc.update(environment.apiUrl+'/PatientCareTaskMaster/UpdateAppointmentStatusDoneFlag',Det,params).pipe(takeUntil(this.unsubscribe$)).subscribe((data:any)=>{
        if(data.code == 200){
          this.loadList.forEach(item => {
            if(item.pcId == x.pcId){
              item.careTaskStatus = 5;
              
            }        
            }
          );
          event.target.disable=false;
          this.successFlag = true;
          setTimeout(()=>{
            this.successFlag = false;
          },4000)
        }
     },(error) => {
      event.target.disable=false;
      this.failFlag = true;
          setTimeout(()=>{
            this.failFlag = false;
          },4000)
     }, () => {
     });}

      loadInj(){
        this.medicineSrvc.list("medicine/" + this.tenantId + '/' + this.branchId).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
          this.medicineData = data.value.filter(x => x?.medicineCategoryId == "9500da85-74ba-4083-b97a-08d8bdfe9ce9");}
        )}
exportList(type) {
    var ExportData = [];
    var header = {};
    let fileName = "";
    var data = [];

    if (this.pagename == 'Appointment' || this.pagename == 'Admission'||this.pagename =='cathlab'||this.pagename =='diet') {
      fileName = this.pagename + " Request Queue";
      header = {
        value1: "SNo",
        value2: "Referral Details",
        value3: "Patient Details",
        value4: 'Recommended Date/Time',
        value5: 'Reason for Referral',
        value6: 'Doctor Details',
        value7: 'Mode',
        value8: 'Status',
       value9: 'Counsellor Name',
        value10: 'Counselling Date'

      }
      ExportData = this.loadList.map((list, index) => {
        return {
          value1: index + 1,
          value2: `${this.opFlag==13?"Admission":"Appointment"} Referral\n#` + list?.inputJson?.oldApp,
          value3: list?.firstname + "\n" + "Mobile:" + list?.mobile + " || #" + list?.regNum,
          value4: this.onCalculation(this.opFlag == 13?list?.inputJson?.Admissionperiod :list?.inputJson?.Appointmentperiod) + "\n" + this.dateobj.dateUtctoLocal(list?.inputJson?.DateTime, 'DD-MM-YYYY h:mm:ss a'),
          value5: list?.inputJson?.Reason,
          value6: (list?.inputJson?.docName !== '' ? 'Dr.' + list?.inputJson?.docName : '-') + "\n" + (list?.inputJson?.Type != false ? list?.inputJson?.Type : ""),
          value7: list?.inputJson?.Mode != false ? list?.inputJson?.Mode : "",
          value8: list?.careTaskStatus == 4 ? 'New' : 'Completed',
          value9: this.getcounsellerName(list.pcId),
          value10: this.getcounsellerDate(list.pcId)
        }
      });

      const referType=this.searchForm.get('type')?.value==13?"Admission":"Appointment";
      const status=this.searchForm.get('status')?.value;
      const priority=this.searchForm.get('priority')?.value;
      const reason=this.searchForm.get('reason')?.value;
      const period=this.searchForm.get('period')?.value;
      const mobile=this.searchForm.get('mobile')?.value;
      const regId=this.searchForm.get('regId')?.value;
      const search=this.searchForm.get('search')?.value;

      data.push({
        value1: `Search terms ${(this.searchForm.get('type')?.value !== null && this.searchForm.get('type')?.value !== "" && this.searchForm.get('type')?.value != undefined) ? "Type:" + referType : ""}  ${(search!== null && search!== "" && search != undefined) ? "Search:" + search : ""}  ${(regId!== null && regId!== "" && regId != undefined) ? "Reg No:" + regId : ""}  ${(mobile !== null && mobile !== "" && mobile!= undefined) ? "Mobile: " + mobile : ""}  ${(reason !== null && reason!== "" && reason != undefined) ? "Category Reason:" + this.findCategory(reason) : ""}   ${(priority !== null && priority !== "" && priority != undefined) ? "Priority:" + this.findPriority(priority): ""}  ${(status !== null && status !== "" && status != undefined) ? 'Status:' + this.getStatus(status) : ""}  ${(period !== null && period!== "" && period != undefined) ? "Period:" + period : ""}  From Date: ${this.dateobj.dateUtctoLocal(this.fromDate, 'DD-MM-YYYY h:mm:ss a')}  End Date: ${this.dateobj.dateUtctoLocal(this.toDate, 'DD-MM-YYYY h:mm:ss a')}`,
      }
      )
    }
    else if (this.TabFlag == 'Counsel') {
      fileName = "Counselling Queue";
      header = {
        value1: "SNo",
        value2: "Patient Details",
        value3: 'Counselling Name',
        value4: 'Counsellor Details',
        value5: 'Planned Duration',
        value6: 'Status',
        value7: 'Call Status',
        value8: 'Patients Final Status',
         value10:'Counselling Done on',
      }
      ExportData = this.loadList.map((list, index) => {
        return {
          value1: index + 1,
          value2: list?.firstname + "\n" + "Mobile:" + list?.mobile + " || #" + (list?.unregisterPatient == false ? list?.regNum + ' || Not Yet Registered' : list?.regNum),
          value3: list?.inputJson?.counsellingName,
          value4: list?.inputJson?.counsellorName,
          value5: list?.inputJson?.durationId != 7 ? list?.inputJson?.duration : this.dateobj.dateUtctoLocal(list?.inputJson?.date, 'DD-MM-YYYY h:mm:ss a') + "-" + this.dateobj.dateUtctoLocal(list?.inputJson?.endDate, 'DD-MM-YYYY h:mm:ss a'),
          value6: list?.careTaskStatus
            == 4 ? 'Scheduled' : 'Counselling Completed',
	              value7: list?.patientCallStatus,
          value8: list?.patientFinalStatus,
          value10: list?.doneDateTime? this.dateobj.dateUtctoLocalDateAndTime(list.doneDateTime): null
        }
      });
      data.push({
        value1: `Search terms ${(this.CregId !== null && this.CregId !== "" && this.CregId != undefined) ? "Reg No:" + this.CregId : ""}  ${(this.Cmobile !== null && this.Cmobile !== "" && this.Cmobile != undefined) ? "Mobile: " + this.Cmobile : ""}  ${(this.counsellingType !== null && this.counsellingType !== "" && this.counsellingType != undefined) ? "Counselling Name:" + this.findCounsellingName( this.counsellingType ): ""} ${(this.Cstatus !== null && this.Cstatus !== "" && this.Cstatus != undefined) ? 'Status:' + this.getCStatus(this.Cstatus) : ""}  ${(this.Cperiod !== null && this.Cperiod !== "" && this.Cperiod != undefined) ? "Period:" + this.Cperiod : ""}  From Date: ${this.dateobj.dateUtctoLocal(this.fromDate, 'DD-MM-YYYY h:mm:ss a')}  End Date: ${this.dateobj.dateUtctoLocal(this.toDate, 'DD-MM-YYYY h:mm:ss a')}`,
      }
      )
    }
    else if (this.TabFlag == 'Vaccine') {
      fileName = "Vaccine Queue";
      header = {
        value1: "SNo",
        value2: "Patient Details",
        value3: 'Vaccine Name',
        value4: 'Notes',
        value5: 'Status'

      }
      ExportData = this.loadList.map((list, index) => {
        return {
          value1: index + 1,
          value2: list?.firstname + "\n" + "Mobile:" + list?.mobile + " || #" + (list?.unregisterPatient == false ? list?.regNum + ' || Not Yet Registered' : list?.regNum),
          value3: list?.inputJson?.name,
          value4: list?.inputJson?.notes,
          value5: list?.careTaskStatus
            == 4 ? 'Scheduled' : 'Vaccine Completed',
        }
      });

      data.push({
        value1: `Search terms ${(this.Vreg !== null && this.Vreg !== "" && this.Vreg != undefined) ? "Reg No:" + this.Vreg : ""}  ${(this.Vmobile !== null && this.Vmobile !== "" && this.Vmobile != undefined) ? "Mobile: " + this.Vmobile : ""}  ${(this.VaccineName !== null && this.VaccineName !== "" && this.VaccineName != undefined) ? "Vaccine Name:" + this.getVaccineName() : ""} ${(this.Vstatus !== null && this.Vstatus !== "" && this.Vstatus != undefined) ? 'Status:' + (this.Vstatus=='4'?'Scheduled':'Vaccine Completed') : ""}  ${(this.Vperiod !== null && this.Vperiod !== "" && this.Vperiod != undefined) ? "Period:" + this.Vperiod : ""}  From Date: ${this.dateobj.dateUtctoLocal(this.fromDate, 'DD-MM-YYYY h:mm:ss a')}  End Date: ${this.dateobj.dateUtctoLocal(this.toDate, 'DD-MM-YYYY h:mm:ss a')}`,
      }
      )
    }
    else if (this.TabFlag == 'Injection') {
      fileName = "Injection Queue";
      header = {
        value1: "SNo",
        value2: "Patient Details",
        value3: 'Injection Name',
        value4: 'Notes',
        value5: 'Status'

      }
      ExportData = this.loadList.map((list, index) => {
        return {
          value1: index + 1,
          value2: list?.firstname + "\n" + "Mobile:" + list?.mobile + " || #" + (list?.unregisterPatient == false ? list?.regNum + ' || Not Yet Registered' : list?.regNum),
          value3: list?.inputJson?.name,
          value4: list?.inputJson?.notes,
          value5: list?.careTaskStatus
            == 4 ? 'Scheduled' : 'Injection Completed',
        }
      });

      data.push({
        value1: `Search terms ${(this.Ireg !== null && this.Ireg !== "" && this.Ireg != undefined) ? "Reg No:" + this.Ireg : ""}  ${(this.Imobile !== null && this.Imobile !== "" && this.Imobile != undefined) ? "Mobile: " + this.Imobile : ""}  ${(this.InjectionName !== null && this.InjectionName !== "" && this.InjectionName != undefined) ? "Injection Name:" + this.getInjectionName() : ""} ${(this.Istatus !== null && this.Istatus !== "" && this.Istatus != undefined) ? 'Status:' + this.getIStatus(this.Istatus) : ""}  ${(this.Iperiod !== null && this.Iperiod !== "" && this.Iperiod != undefined) ? "Period:" + this.Iperiod : ""}  From Date: ${this.dateobj.dateUtctoLocal(this.fromDate, 'DD-MM-YYYY h:mm:ss a')}  End Date: ${this.dateobj.dateUtctoLocal(this.toDate, 'DD-MM-YYYY h:mm:ss a')}`,
      }
      )
    }
    else if (this.TabFlag == 'Therapy') {
      fileName = "Theraphy Queue";
      header = {
        value1: "SNo",
        value2: "Patient Details",
        value3: 'Therapy Name',
        value4: 'Therapist Details',
        value5: 'Planned Duration',
        value6: 'Status'

      }
      ExportData = this.loadList.map((list, index) => {
        return {
          value1: index + 1,
          value2: list?.firstname + "\n" + "Mobile:" + list?.mobile + " || #" + (list?.unregisterPatient == false ? list?.regNum + ' || Not Yet Registered' : list?.regNum),
          value3: this.therapyFtn(list?.inputJson?.Description),
          value4: "Dr. " + this.getTherapistName(list?.inputJson?.Therapist),
          value5: list?.inputJson?.Duration != 7 ? this.getDurationNamebyId(list?.inputJson?.Duration) : this.dateobj.dateUtctoLocal(list?.inputJson?.Date, 'DD-MM-YYYY h:mm:ss a') + "-" + this.dateobj.dateUtctoLocal(list?.inputJson?.EndDate, 'DD-MM-YYYY h:mm:ss a'),
          value6: list?.careTaskStatus
            == 4 ? 'Scheduled' : 'Therapy Completed',
        }
      });

      data.push({
        value1: `Search terms ${(this.therpyterm !== null && this.therpyterm !== "" && this.therpyterm != undefined) ? "Reg No:" + this.therpyterm : ""}  ${(this.mobileTerm !== null && this.mobileTerm !== "" && this.mobileTerm != undefined) ? "Mobile: " + this.mobileTerm : ""}  ${(this.therapy !== null && this.therapy !== "" && this.therapy != undefined) ? "Therapy Name:" + this.therapyFtn(this.therapy) : ""}  ${(this.therapist !== null && this.therapist !== "" && this.therapist != undefined) ? 'Therapist: Dr.' + this.getTherapistName(this.therapist) : ""}  ${(this.Tstatus !== null && this.Tstatus !== "" && this.Tstatus != undefined) ? 'Status:' + this.getTStatus(this.Tstatus) : ""}  ${(this.Tperiod !== null && this.Tperiod !== "" && this.Tperiod != undefined) ? "Period:" + this.Tperiod : ""}  From Date: ${this.dateobj.dateUtctoLocal(this.fromDate, 'DD-MM-YYYY h:mm:ss a')}  End Date: ${this.dateobj.dateUtctoLocal(this.toDate, 'DD-MM-YYYY h:mm:ss a')}`,
      }
      )
    }else if (this.TabFlag == 'PatientCare') {
      fileName = "Patient Care Queue";
      header = {
        value1: "SNo",
        value2: "Patient Details",
        value3: 'Patient Care Name',
        value4: 'Physician',
        value5: 'Status',
      }
      ExportData = this.loadList.map((list, index) => {
        return {
          value1: index + 1,
          value2: list?.firstname + "\n" + "Mobile:" + list?.mobile + " || #" + (list?.unregisterPatient == false ? list?.regNum + ' || Not Yet Registered' : list?.regNum),
          value3: list?.inputJson?.careName,
          value4: 'Dr.'+list?.inputJson?.doctorName,
          value5: list?.careTaskStatus
            == 4 ? 'Scheduled' : (list?.careTaskStatus
            == 6?'Hold':'Completed'),
        }
      });
      data.push({
        value1: `Search terms ${(this.CareregId !== null && this.CareregId !== "" && this.CareregId != undefined) ? "Reg No:" + this.CareregId : ""}  ${(this.Caredoc !== null && this.Caredoc !== "" && this.Caredoc != undefined) ? "Physician: " + this.Caredoc : ""}  ${(this.patientCare !== null && this.patientCare !== "" && this.patientCare != undefined) ? "Patient Care Name:" + this.findCareName( this.patientCare ): ""} ${(this.Carestatus !== null && this.Carestatus !== "" && this.Carestatus != undefined) ? 'Status:' + this.getCareStatus(this.Carestatus) : ""}  ${(this.Careperiod !== null && this.Careperiod !== "" && this.Careperiod != undefined) ? "Period:" + this.Careperiod : ""}  From Date: ${this.dateobj.dateUtctoLocal(this.fromDate, 'DD-MM-YYYY h:mm:ss a')}  End Date: ${this.dateobj.dateUtctoLocal(this.toDate, 'DD-MM-YYYY h:mm:ss a')}`,
      }
      )
    }
    else if (this.TabFlag == 'CommunicationOrder') {
      fileName = "Communication Order Queue";
      header = {
        value1: "SNo",
        value2: "Patient Details",
        value3: 'Instruction',
        value4: 'Other Notes',
        value5: 'Type',
        value6: 'Status',
        value7: 'Start DateTime'
      }
      ExportData = this.loadList.map((list, index) => {
        return {
          value1: index + 1,
          value2: list?.firstname + "\n" + "Mobile:" + list?.mobile + " || #" + (list?.unregisterPatient == false ? list?.regNum + ' || Not Yet Registered' : list?.regNum),
          value3: list?.inputJson?.instruction,
          value4: list?.inputJson?.otherNotes||'-',
          value5:list?.inputJson?.communicationField,
          value6: list?.careTaskStatus
            == 4 ? 'Scheduled' : (list?.careTaskStatus
            == 7?'Cancelled':(list?.careTaskStatus == 8?'InProgress':(list?.careTaskStatus == 6?'Hold':'Completed'))),
          value7:this.dateobj?.dateUtctoLocal(list?.inputJson?.startDate, 'DD-MM-YYYY h:mm:ss a')
        }
      });
      data.push({
        value1: `Search terms ${(this.CareregId !== null && this.CareregId !== "" && this.CareregId != undefined) ? "Reg No:" + this.CareregId : ""}  ${(this.Caredoc !== null && this.Caredoc !== "" && this.Caredoc != undefined) ? "Physician: " + this.Caredoc : ""}  ${(this.patientCare !== null && this.patientCare !== "" && this.patientCare != undefined) ? "Patient Care Name:" + this.findCareName( this.patientCare ): ""} ${(this.Carestatus !== null && this.Carestatus !== "" && this.Carestatus != undefined) ? 'Status:' + this.getCareStatus(this.Carestatus) : ""}  ${(this.Careperiod !== null && this.Careperiod !== "" && this.Careperiod != undefined) ? "Period:" + this.Careperiod : ""}  From Date: ${this.dateobj.dateUtctoLocal(this.fromDate, 'DD-MM-YYYY h:mm:ss a')}  End Date: ${this.dateobj.dateUtctoLocal(this.toDate, 'DD-MM-YYYY h:mm:ss a')}`,
      }
      )
    }


    data.push(
      {
        value1: '',
      },

      header,
      ...ExportData,
    );



    this.filexport.newExcelExport(type, data, header, fileName);
  }
    getcounsellerName(pcId){
  return  this.editlistData?.find(item => item.parentId === pcId)?.parsedJson.counsellorName ?? '-'
  }
getcounsellerDate(parentId: number): string {
  if (!parentId || !this.editlistData?.length) {
    return '-';
  }

  const item = this.editlistData.find(i => i.parentId === parentId);

  if (!item || !item.parsedJson.counsellingDate) {
    return '-';
  }

  const localDate = this.dateobj.dateUtctoLocalDateAndTime(item.parsedJson.counsellingDate);

  return this.datePipe.transform(localDate, 'fullDate') ?? '-';
}
  alreadyAdmitted(reg){
    if(!!reg){
      return !!this.admittedlist.find(x => x?.regId === reg)?true:false;
    }else{
      return false;
    }
  }
  onCancel(){
    this.vaccineFlag =false;
    this.VaccineMstData = {};
    this.isSubmitted = false;
    this.patientvaccineForm?.reset();
  }

 
  selectMedicine(event){
    this.selectedMedicine=event[0]?.data;
    if(this.selectedMedicine.totalStock>0){
    this.stockDetforVaccineAdjust = {
      medicineID: this.selectedMedicine.medicineid,
      batchNumber: this.selectedMedicine.batchNumber,
      expiryDate: this.selectedMedicine.expiryDate,
      pricePerStrips: this.selectedMedicine.pricePerStrips,
      sellPriceStrip: this.selectedMedicine.sellPriceStrip,
      mrpPerStrip: this.selectedMedicine.mrpPerStrip,
      gstTotalPer: this.selectedMedicine.gstTotalPer,
      referenceNo: "0",
      referenceDate: new Date().toISOString(),
      stockType: "STOCK_MINUS",
      stockIn: 0,
      stockOut: 1,
      createdBy: this.createdBy,
      createdDate: new Date().toISOString(),
      tenantId: this.tenantId,
      branchId: this.branchId,
      branchType: "Chennai",
      pharmacyId: this.selectedMedicine.counterId,
      newGst: "0",
      unitCostPrice: parseFloat((this.selectedMedicine.pricePerStrips / this.selectedMedicine.unit).toFixed(2)),
      unitSellPrice: this.selectedMedicine.unitSellPrice,
      unitMrpPrice: parseFloat((this.selectedMedicine.mrpPerStrip / this.selectedMedicine.unit).toFixed(2)),
     
      unitFlag: "false",
      warehouseId: this.selectedMedicine.warehouseId || null,
      pharmcyCounterId: this.selectedMedicine.counterId || null
    };
  }

  }

  pharmacyCounterData: Array<any> = [];
  warehouseId: number;
  pharmacyId: number;

  getCounterData(): Observable<any> {
    const userId = parseInt(localStorage.getItem("userId"));
    return this.salesObj.list(`${environment.apiUrl}/Pharmacy/${this.tenantId}/${this.branchId}/PharmacyCounterSetting/${userId}`).pipe(
      takeUntil(this.unsubscribe$),
      tap((data: any) => {
        if (Array.isArray(data)) {
          this.pharmacyCounterData = (data || []).map(e => ({...e.phCounterDet, isDefaultFlag: e.isDefaultFlag}))?.filter(item => item.salesCounterFlag === "true") || [];
        }
        if (this.pharmacyCounterData.length > 0) {
          const defaultCounter = this.pharmacyCounterData.find(x => x.isDefaultFlag === true);
          this.warehouseId = defaultCounter?.salesWarehouse;
          this.pharmacyId = defaultCounter?.id;
        }
      })
    );
  }

  getMedicineDet(): Observable<any> {
    const searchData = {
      fromDate: null,
      toDate: null,
      skip: 0,
      take: 100,
      medicine: null,
      category: null,
      manufacture: null,
      warehouseId: this.warehouseId || null,
      pharmacyId: this.pharmacyId || null
    };
  
    // SECURITY/BUGFIX: the API rejects this endpoint's response with 406 Not Acceptable when
    // Accept is application/vnd.ezovion.hateoas+json (searchList's default) - this action isn't
    // a HATEOAS resource, so request plain JSON instead.
    return this.salesObj.searchList(`PhStockDet/${this.tenantId}/${this.branchId}/VaccineStockOnly`, searchData,
      { headers: { "Accept": "application/json", "Content-Type": "application/json" } })
      .pipe(
        takeUntil(this.unsubscribe$),
        tap((data: any) => {
          this.medicineValue = data;
          this.medicineValue.forEach(med => {
            med.LocalExpiryDate = new Date(med.expiryDate);
          });
        })
      );
  }
  
  performDoc(): Observable<any> {
    return this.medicineSrvc.list(`physicians/${this.tenantId}/${this.branchId}/GetAllInternalDoctor`)
      .pipe(
        takeUntil(this.unsubscribe$),
        tap((data: any) => {
          this.performDocList = data;
        })
      );
  }
  
  performNurse(): Observable<any> {
    return this.medicineSrvc.list(`tenants/${this.tenantId}/${this.branchId}/employee/getEmployeeByCategory?tenantId=${this.tenantId}&branchId=${this.branchId}&jobcategory=2`)
      .pipe(
        takeUntil(this.unsubscribe$),
        tap((data: any) => {
          this.performNurseList = data.details;
        })
      );
  }
  
  VaccFlag(x: any) {
    this.getCounterData().pipe(
      switchMap(() => this.getMedicineDet()),
    ).subscribe({
      next: () => {
        this.vaccineFlag = true;
        this.phcharflag = false;
        this.VaccineMstData = x;
        this.patientvaccineForm?.get('notes')?.setValue(x?.inputJson?.notes);
        this.patientvaccineForm?.get('performDoc')?.setValue(x?.inputJson?.performingDoctor);
        this.patientvaccineForm?.get('regId')?.setValue(x?.inputJson?.regId);
        this.patientvaccineForm?.get('doseNumber')?.setValue(x?.inputJson?.doseNumber);
      },
      error: (err) => {

      }
    });
  }

  // Suppose dataList contains your API data
// parentId is passed as parameter
getAdmissionDatesByParentId(parentId: number): string {
  if (!parentId || !Array.isArray(this.rootMappingDetails)) {
    return ' - ';
  }

  const dates = this.rootMappingDetails
    .filter(x => x?.parentId === parentId && x?.inputJson)
    .map(item => {
      try {
        const input = JSON.parse(item.inputJson);
        const dateUtc = input?.DateTime;
        if (!dateUtc) {
          return null;
        }

        const localDate = new Date(dateUtc);
        if (isNaN(localDate.getTime())) {
          return null;
        }

        const options: Intl.DateTimeFormatOptions = {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        };

        return localDate.toLocaleDateString(undefined, options);
      } catch {
        return null;
      }
    })
    .filter(Boolean); // remove nulls

  return dates.length ? dates.join(', ') : ' - ';
}




  openVacc(event) {
    this.isSubmitted = true;
    event.target.disabled = true;
    if (!this.patientvaccineForm.get('confirmVaccination')?.value) {
      this.vaccineCheckBoxError = true;
      return;
    } else {
      this.vaccineCheckBoxError = false;
    }
    if (this.patientvaccineForm.valid && this.selectedMedicine.totalStock>0) {

      let index = (this.commList as Array<any>).findIndex(x => x.key == "billing");
      let templateData = (this.commList[index].type as Array<any>);
      const x = this.VaccineMstData?.inputJson;
      const y = this.VaccineMstData;

      const holdbill = {
        discountValue: 0,
        discountAmount: 0,
        taxAmount: 0,
        netAmount: this.stockDetforVaccineAdjust.unitSellPrice,
        discountType: null,
        totalAmount: this.stockDetforVaccineAdjust.unitSellPrice,
        tenantId: this.tenantId,
        branchId: this.branchId,
        taxPercentage: 0,
        billDate: this.dateobj.currentDate(),
        regId: this.patientvaccineForm?.get('regId').value,
        status: "Pending",
        physicianId: this.patientvaccineForm.get('performDoc').value,
        paidAmount: 0,
        balanceAmount: this.stockDetforVaccineAdjust.unitSellPrice,
        billNumber: "",
        paidTemplateId: templateData[0].template_id,
        holdTemplateId: templateData[1].template_id,
        emergencyFlag: "N",
        woid: null,
        updatedBy: this.createdBy,
        updatedDate: this.dateobj.currentDate(),
        updatedIP: null,
        createdBy: this.createdBy,
        createdDate: this.dateobj.currentDate(),
        createdIP: null,
        cancelFlag: "No",
        cancelReason: null,
        isActive:true,
        gstTotal: 0,
        gstType: null,
        referralType: 1,
        internalReferralId: null,
        externalReferralId: null,
        lock: false,
        billCounter: null
      }
      const serviceId = localStorage.getItem("vaccineService") == "null" ? null : localStorage.getItem("vaccineService");
      let holdServiceDetails = [{
        billId: 0,
        serviceId: serviceId,
        serviceType: "",
        rate: this.stockDetforVaccineAdjust.unitSellPrice,
        qty: 1,
        charges: this.stockDetforVaccineAdjust.unitSellPrice,
        refMode: "",
        refEmpId: "",
        refClinicId: "",
        isEditable: "Y",
        refDocId: this.patientvaccineForm.get('performDoc').value,
        othersName: "",
        othersPhone: "",
        othersAddress: "",
        reqDiscountPercentage: 0,
        reqDiscountType: null,
        reqDiscountAmount: 0,
        serviceDiscountPercentage: 0,
        serviceDiscountType: null,
        serviceDiscountAmount: 0,
        serviceNetAmount: this.stockDetforVaccineAdjust.unitSellPrice,
        branchId: this.branchId,
        tenantId: this.tenantId,
        zeroServiceFlag: "InActive",
        gstPercentage: 0,
        gstAmount: 0.00,
        gstWithAmount: this.stockDetforVaccineAdjust.unitSellPrice,
        taxableAmount: this.stockDetforVaccineAdjust.unitSellPrice,
        sgst: 0.00,
        cgst: 0.00,
        igst: 0,
        arrow: false,
        healthCardDisc: null,
        referralDisc: null,
        referralDiscPer: null,
        loyaltyDisc: null,
        loyaltyDiscPer: null
      }]

      const patientimmunicationupdatedata = {
        immunicationId: x?.id,
        //doneDate: this.dateobj.dateWithOffset(this.patientvaccineForm?.get('done_Date')?.value),
        doneDate: this.patientvaccineForm?.get('done_Date')?.value,
        notes: this.patientvaccineForm?.get('notes')?.value,
        tenantId: localStorage.getItem("tenantId"),
        branchId: localStorage.getItem("branchId"),
        pcId: y?.pcId,
        holdBill: holdbill,
        currentStock: this.selectedMedicine.totalStock,
        holdBillDetail: holdServiceDetails,
        stockDet: this.stockDetforVaccineAdjust,
        performingDoctor: this.patientvaccineForm?.get('performDoc')?.value,
        performingNurse: this.patientvaccineForm?.get('performNurse')?.value,
        PerformingDoctorName:this.loadDatadet('doc',this.patientvaccineForm?.get('performDoc')?.value),
        PerformingNurseName:this.loadDatadet('nurse',this.patientvaccineForm?.get('performNurse')?.value),
        MedicineName:this.loadDatadet('meds',this.patientvaccineForm?.get('medicineId')?.value),
        doseNumber: this.patientvaccineForm?.get('doseNumber')?.value != null ? Number(this.patientvaccineForm?.get('doseNumber')?.value) : 0
      };


      this.vopdSrvc.update(environment.apiUrl + "/PatientCareTaskMaster/UpdateVaccineStatusDoneFlag", patientimmunicationupdatedata).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        if (data.code == 200) {
          this.loadList.forEach(item => {
            if (item.pcId == y?.pcId) {
              item.careTaskStatus = 5;
              item.inputJson.notes = this.patientvaccineForm?.get('notes')?.value;
              item.inputJson.medicineName=this.loadDatadet('meds',this.patientvaccineForm?.get('medicineId')?.value)
              item.inputJson.performingDoctorName=this.loadDatadet('doc',this.patientvaccineForm?.get('performDoc')?.value)
              item.inputJson.performingNurseName=this.loadDatadet('nurse',this.patientvaccineForm?.get('performNurse')?.value)
              y.inputJson.unitsellprice = this.selectedMedicine?.unitSellPrice

            }
          })
        }
      }, () => {
        event.target.disabled = false;
      }, () => {
        this.isSubmitted = false;
        event.target.disabled = false;
        this.successFlag = true;
        setTimeout(() => {
          this.successFlag = false;
        }, 4000)

        this.abhaPrescriptionLinkSrvc.autoLinkCareContext(this.tenantId, this.branchId, this.VaccineMstData?.regId, Number(this.VaccineMstData?.visitId), ['ImmunizationRecord']);

        this.onCancel();
      })
    } else {
      event.target.disabled = false;
      this.patientvaccineForm.markAllAsTouched(); 
    }
  }

  valueChange(value) { 
    const val = (value?.target as HTMLTextAreaElement)?.value;
    if(val!=null)
       this.phlen=100 - val?.length; 
   }
  phchange(){
    this.phcharflag=true;
  }
  pageTaskIds:Array<any>=[]
  userAccessData:Array<any>=[]
  isPrint:boolean=true
  isExport:boolean=true
  fetchPageAccess() {
    this.pageTaskIds = [];
    this.pageTaskIds.push(access.task.TASKORDER, access.task.TASKORDERCOUNSELLING);
    let matrixSearchData: any = {
      taskId: this.pageTaskIds,
      UserId: localStorage.getItem("userType")
    }
    this.rolesService.create(`${environment.apiUrl}/userrole/${this.tenantId}/${this.branchId}/pageaccesssearch`, matrixSearchData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.userAccessData = data;
      let isPrint = this.userAccessData.filter(element => access.task.TASKORDER == element.taskID && element.actionID == access.action.PRINT && element.permission == "true" )
        if(isPrint.length > 0) {this.isPrint = true}
        let isExport = this.userAccessData.filter(element => access.task.TASKORDER == element.taskID && element.actionID == access.action.EXPORT && element.permission == "true" )
        if(isExport.length > 0) {this.isExport = true}
          let counsellingCreate = this.userAccessData.some(element => access.task.TASKORDERCOUNSELLING == element.taskID && element.actionID == access.action.CREATE && element.permission == "true");
          this.isCounsellingCreate=counsellingCreate;

            let counsellingUpdate = this.userAccessData.some(element => access.task.TASKORDERCOUNSELLING == element.taskID && element.actionID == access.action.EDIT && element.permission == "true");
          this.isCounsellingUpdate=counsellingUpdate;
    }, (error) => {
    }, () => {
  
    
    
    });
  }  

  fetchTenantBasedList(){
      if(this.commonType?.length > 0){return}
        const masterTypes={
          masterTypes: ["PATIENT_CARE"]
        }                                //from reason-master
        this.rolesService.create(`${environment.apiUrl}/tenants/${this.tenantId}/masterreason/${this.branchId}/getMultipleTenantBasedMasters`, masterTypes).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
          const physioDropdownList = data.details;
          this.commonType = physioDropdownList.filter(each => each.mrType === 'PATIENT_CARE' && each.isActive==true);
        })
      }
  goToDiet(x:any){
      this.router.navigate(
    ['pages/diet/diet-examination'],
    {state: {
      appointmentId: x?.appointmentId,
      regId: x?.regId,
      visitId: x?.visitId,
      admissionId: x?.admissionId,
      pcId: x?.pcId,
      performingDoctor : x?.inputJson?.Doctor
    } }
  );
  }
savePatientCallStatusUpdate() {
    this.patientStatusUpdateFormSubmitted = true;
    if (this.patientStatusUpdateForm.valid) {

      const payload = {
        "tenantId": this.tenantId,
        "branchId": this.branchId,
        "pcId": this.primaryKey,
        "patientCallStatus": this.patientStatusUpdateForm.get('patientCallStatus').value,
        "patientFinalStatus": this.patientStatusUpdateForm.get('patientFinalStatus').value,
        "careTaskStatus": this.patientStatusUpdateForm.get('counsellingStatus').value,
        "remarks": this.patientStatusUpdateForm.get('remarks').value,
        "doneDateTime": this.patientStatusUpdateForm.get('counsellingDate').value,
        "fromDate": this.dateobj.utcFromDate(this.fromDate),
        "toDate": this.dateobj.utcToDate(this.toDate),
        "careTaskType": this.searchForm.get('type')?.value

      }
      this.rolesService.create(`${environment.apiUrl}/PatientCareTaskMaster/updatePatientTaskStatus`, payload).pipe(takeUntil(this.unsubscribe$)).subscribe((responseData: any) => {
        this.openPatientStatusPopup = false;
        this.commonListPage(responseData);

        this.showPopupStatusUpdate=true;
      setTimeout(() => {
        this.showPopupStatusUpdate = false;
      }, 2000)
      })

    }

  }

  isActionVisible(y: any): boolean {
  if (y?.careTaskStatus !== 4 || y?.alreadyadmit) {
    return false;
  }

  if (this.opFlag === 13) {
    return this.isAdmissionCreate;
  }

  return true;
}

get isAdmissionMode(): boolean {
  return this.opFlag === 13;
}

  UpdatePatientCounsellingStatusMeth() {
      const payload = {
        "tenantId": this.tenantId,
        "branchId": this.branchId,
        "id": this.primaryKey,
        "fromDate": this.dateobj.utcFromDate(this.fromDate),
        "toDate": this.dateobj.utcToDate(this.toDate),
        "careTaskType": this.searchForm.get('type')?.value,
        StatusId:this.StatusId
      }
      this.rolesService.create(`${environment.apiUrl}/PatientCareTaskMaster/updatePatientCounsellingStatus`, payload).pipe(takeUntil(this.unsubscribe$)).subscribe((responseData: any) => {
        this.openCounsellingStatusPopup = false;
        this.commonListPage(responseData);
      })
  }

  goToPatientBedReservations(patientData:Record<string,any>){
    if(patientData?.regNum){
      this.router.navigate(['/pages/crm/enquiry-master'],{queryParams:{fromPageName:'patientReferral',regNum:patientData?.regNum}})
    }
  }

  goToPatientWallet(patientData:Record<string,any>){
    if(patientData?.regId){
      this.router.navigate([`pages/patientservices/patient-wallet/${patientData?.regId}`])
    }
  }

  getReservations(data:Record<string,any>):Boolean{
    return (this.bedReservationDet?.filter(e=>e?.regId==data?.regId)?.length > 0 )? true : false;
  }
 
  getReservationsDet(data:Record<string,any>):Array<any>[]{
    return this.bedReservationDet?.filter(e=>e?.regId==data?.regId) || [];
  }
  
  getLoadList():Array<any>[]{
    return this.loadList?.sort((a, b) => { return new Date(b?.createdDate)?.getTime() - new Date(a?.createdDate)?.getTime();
    }) || [];
  }

OnClickRereferal(x){
this.isRereferal=true;
this.reRefralId=x.pcId;
this.regId = x.regId;
this.visitId = x.visitId;
this.refDocId=x.inputJson.docid;
}
savedRerefarral(){
  this.isRereferal=false;
  this.onLoad();
}
}